module.exports = "/_next/static/images/Iso27017@2x-c41c4caf7e0dec919409188f1d3ce341.png";